
import { BookingItem } from "@/models/www/store/BookingSummary";
import { defineComponent, PropType } from "vue";

export default defineComponent({
	props: {
		modeOfTravel: String,
		serviceType: String,
		passengers: {
			type: Array as PropType<BookingItem[]>,
			default: () => [],
		},
		campaign: {
			type: String,
			required: false,
		},
	},
});
